import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_83: FaireProductEntity = {
  token: "legacy_prod_abbott-83",
  type: "product",
  name: "Large Wild Forest Animals Napkins, 20 Pack",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5207f70ef8662e103543e8a18bcf555514a67a3300a672288e03842f9a7bfcfc.jpeg",
  priceDollars: 12,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_party-supplies"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
